export const LogscordComparisonCards = [
    {
        icon: "speed",
        titleKey: "compare.card.noise.title",
        descriptionKey: "compare.card.noise.description",
    },
    {
        icon: "fact_check",
        titleKey: "compare.card.certainty.title",
        descriptionKey: "compare.card.certainty.description",
    },
    {
        icon: "admin_panel_settings",
        titleKey: "compare.card.control.title",
        descriptionKey: "compare.card.control.description",
    },
];
export const LogscordComparisonRows = [
    ["compare.row.search.label", "compare.row.search.logscord", "compare.row.search.classic"],
    ["compare.row.message.label", "compare.row.message.logscord", "compare.row.message.classic"],
    ["compare.row.voice.label", "compare.row.voice.logscord", "compare.row.voice.classic"],
    ["compare.row.dashboard.label", "compare.row.dashboard.logscord", "compare.row.dashboard.classic"],
    ["compare.row.history.label", "compare.row.history.logscord", "compare.row.history.classic"],
    ["compare.row.proof.label", "compare.row.proof.logscord", "compare.row.proof.classic"],
    ["compare.row.data.label", "compare.row.data.logscord", "compare.row.data.classic"],
];
//# sourceMappingURL=comparison.js.map